import { c as _c } from "react/compiler-runtime";
import { arrayMove } from '@dnd-kit/sortable';
import { FieldsType } from '@systemeio/digital-store-shared';
import { ContactSlugEnum, FieldErrorAndDescription, getContactFieldTitle } from '@systemeio/ui';
import StoreAddField from 'modules/stores/store/components/contact-fields/components/store-add-field';
import StoreField from 'modules/stores/store/components/contact-fields/components/store-field';
import { useStoreContactFields } from 'modules/stores/store/hooks/use-store-contact-fields';
import React, { FC } from 'react';
import { Loader } from 'shared/components/loader';
import Sortable from 'shared/components/sortable';
export interface InitFieldsInterface {
  slug: ContactSlugEnum;
  required: boolean;
  mandatory: boolean;
}
interface StoreFieldsProps {
  fields: FieldsType[];
  onChange: (fields: FieldsType[]) => void;
  initFields?: InitFieldsInterface[];
  error?: string;
}
const StoreFields: FC<StoreFieldsProps> = t0 => {
  const $ = _c(19);
  const {
    fields,
    onChange,
    error,
    initFields
  } = t0;
  let t1;
  if ($[0] !== fields || $[1] !== initFields || $[2] !== onChange) {
    t1 = {
      initFields,
      onChange,
      savedFields: fields
    };
    $[0] = fields;
    $[1] = initFields;
    $[2] = onChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    availableFields,
    isReady
  } = useStoreContactFields(t1);
  let t2;
  if ($[4] !== fields || $[5] !== initFields || $[6] !== onChange) {
    t2 = field => <StoreField slug={field.slug} key={field.slug} label={getContactFieldTitle(field)} isRequired={field.required} onChangeRequired={value => onChange(fields.map(f => f.slug === field.slug ? {
      ...f,
      required: value
    } : f))} onDelete={slug => onChange(fields.filter(f_0 => f_0.slug !== slug))} initFields={initFields} />;
    $[4] = fields;
    $[5] = initFields;
    $[6] = onChange;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const getField = t2;
  let t3;
  if ($[8] !== fields || $[9] !== onChange) {
    t3 = async (_, activeIndex, overIndex) => onChange(arrayMove(fields, activeIndex, overIndex));
    $[8] = fields;
    $[9] = onChange;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onMoveItem = t3;
  let t4;
  if ($[11] !== availableFields || $[12] !== error || $[13] !== fields || $[14] !== getField || $[15] !== isReady || $[16] !== onChange || $[17] !== onMoveItem) {
    t4 = <>{!isReady ? <Loader className="self-center" /> : <><Sortable draggable={getField} items={fields.map(_temp)} onMove={onMoveItem}>{fields.map(getField)}</Sortable><FieldErrorAndDescription error={error} /><StoreAddField fields={availableFields} onAdd={data => onChange(fields.concat(data))} /></>}</>;
    $[11] = availableFields;
    $[12] = error;
    $[13] = fields;
    $[14] = getField;
    $[15] = isReady;
    $[16] = onChange;
    $[17] = onMoveItem;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};
export default StoreFields;
function _temp(field_0) {
  return {
    ...field_0,
    id: field_0.slug
  };
}